export default "__VITE_ASSET__MBITaB7___"